export const transactionMappingBackup = [
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'ATM-withdrawal',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'CDM-cash-deposit',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'card-charge',
    description: 'CARD'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'card-payment',
    description: 'CARD'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'cash-equivalent-deposit',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'cash-equivalent-withdrawal',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-cheque',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-local-fund-transfer',
    description: 'REMITTANCE'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-overseas-fund-transfer',
    description: 'REMITTANCE'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-cheque',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-local-fund-transfer',
    description: 'REMITTANCE'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-overseas-fund-transfer',
    description: 'REMITTANCE'
  }
];

export const TRANSACTION_DOWNLOAD_HEADER = [
  {
    name: 'Transaction ID',
    label: 'Transaction ID',
    key: 'id'
  },
  {
    name: 'Transaction Date',
    label: 'Transaction Date',
    key: 'date'
  },
  {
    name: 'Account number',
    label: 'Account number',
    key: 'source'
  },
  {
    name: 'Country of Transaction',
    label: 'Country of Transaction',
    key: 'countryOfTransaction'
  },
  {
    name: 'Transaction Currency',
    label: 'Transaction Currency',
    key: 'transactionCurrency'
  },
  {
    name: 'Transaction Amount',
    label: 'Transaction Amount',
    key: 'amount'
  },
  {
    name: 'Account Currency',
    label: 'Account Currency',
    key: 'accountCurrency'
  },
  {
    name: 'Transaction Amount(Account Currency)',
    label: 'Transaction Amount(Account Currency)',
    key: 'transactionCurrencyAmount'
  },
  {
    name: 'Transaction Amount (SGD)',
    label: 'Transaction Amount (SGD)',
    key: 'localCurrencyEquivalent'
  },
  {
    name: 'CR/DR',
    label: 'CR/DR',
    key: 'credit_debit'
  },
  {
    name: 'Transaction Type',
    label: 'Transaction Type',
    key: 'transactionTypeCode'
  },
  {
    name: 'Transaction Description',
    label: 'Transaction Description',
    key: 'type'
  },
  {
    name: 'Originator',
    label: 'Originator',
    key: 'originator'
  },
  {
    name: 'Originator Country',
    label: 'Originator Country',
    key: 'originatorBankCountryCode'
  },
  {
    name: 'Beneficiary Name',
    label: 'Beneficiary Name',
    key: 'beneficiary'
  },
  {
    name: 'Beneficiary Country',
    label: 'Beneficiary Country',
    key: 'beneficiaryBankCountryCode'
  },
  {
    name: 'Cheque Number',
    label: 'Cheque Number',
    key: 'chequeNo'
  },
  {
    name: 'TD Number',
    label: 'TD Number',
    key: 'tellerId'
  },
  {
    name: 'Your Reference',
    label: 'Your Reference',
    key: 'yourReference'
  },
  {
    name: 'Our Reference',
    label: 'Our Reference',
    key: 'ourReference'
  },
  {
    name: 'Bank information',
    label: 'Bank information',
    key: 'bankInfo'
  },
  {
    name: 'Credit Card Number',
    label: 'Credit Card Number',
    key: 'creditCardNumber'
  },
  {
    name: 'MCC',
    label: 'MCC',
    key: 'mcc'
  },
  {
    name: 'Merchant Name',
    label: 'Merchant Name',
    key: 'merchantName'
  },
  {
    name: 'Tranche No.',
    label: 'Tranche No.',
    key: 'trancheNo'
  },
  {
    name: 'Counter Party',
    label: 'Counter Party',
    key: 'counterParty'
  },
  {
    name: 'Originator Address',
    label: 'Originator Address',
    key: 'originatorAddress'
  },
  {
    name: 'Beneficary Address',
    label: 'Beneficary Address',
    key: 'beneficiaryAddress'
  },
  {
    name: 'Remittence Country',
    label: 'Remittence Country',
    key: 'remittanceCountry'
  },
  {
    name: 'Remittence Payment Details',
    label: 'Remittence Payment Details',
    key: 'remittancePaymentDetails'
  },
  {
    name: 'Additional Information`',
    label: 'Additional Information',
    key: 'bankInfo'
  },
  {
    name: 'MSG Type',
    label: 'MSG Type',
    key: 'swiftMsgType'
  },
  {
    name: 'MSG Information',
    label: 'MSG Information',
    key: 'swiftMsgInfo'
  },
  {
    name: 'ATM ID',
    label: 'ATM ID',
    key: 'atmId'
  },
  {
    name: 'ATM Location',
    label: 'ATM Location',
    key: 'atmLocation'
  },
  {
    name: 'Teller ID',
    label: 'Teller ID',
    key: 'tellerId'
  }
];
